import React from "react";

/* Photo-realistic gold oil streak used as a decorative footer band. */
export const OilWave = ({ className = "" }) => (
  <div
    className={`relative w-full overflow-hidden ${className}`}
    aria-hidden="true"
    data-testid="oil-wave"
  >
    <img
      src="/scene/gold_streak.png"
      alt=""
      className="w-full h-40 sm:h-48 lg:h-56 object-cover select-none pointer-events-none"
      draggable={false}
    />
  </div>
);

export default OilWave;
